// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem('adminAuth');
//   return isAuthenticated ? children : <Navigate to="/AdminDashboard" replace />;
// };

// export default ProtectedRoute;






// src/components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();
  
  if (!auth) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedRoute;